// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"318":"45ef0291","998":"b7a01838"}[chunkId] + ".chunk.js";
};